import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider } from '@/components/SidebarNew/ui/sidebar';
import { AppSidebar } from '@/components/SidebarNew/AppSidebar';
import { DashboardHeader } from '@/components/Header/DashboardHeader';
import styles from './DashboardLayout.module.scss';

interface DashboardLayoutProps {
  user?: {
    email: string;
    displayName?: string;
    photoURL?: string;
  };
  children?: React.ReactNode;
}

export function DashboardLayout({
  user = {
    email: 'admin@beqholdings.com',
    displayName: 'Admin',
  }
}: DashboardLayoutProps) {
  const navigate = useNavigate();

  const handleLogout = () => {
    // console.log('Logging out...');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate('/admin/profile');
  };

  return (
    <SidebarProvider defaultOpen={true}>
      <div className={styles.dashboardLayout}>
        {/* Sidebar */}
        <AppSidebar />

        {/* Header Area */}
        <div className={styles.mainContent}>
          <DashboardHeader
            user={user}
            onLogout={handleLogout}
            onProfileClick={handleProfileClick}
          />

          {/* Page Content */}
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
